import { uuid } from "@/utils/string.ts";
import FeedbackIcon from "@/components/icons/agenda/FeedbackIcon.tsx";

interface OptionProps {
  label: string;
  stars: number;
  onStarsChange?: (stars: number) => void;
}

const FeedbackOptionDesktop = (props: OptionProps) => {
  return (
    <div
      className={`flex flex-row items-center justify-between bg-white
         py-2 px-6 rounded-[10px] h-[74px] w-full mx-auto border-solid border-brand-secondary border-2`}
    >
      <p className=" text-brand text-lg leading-[100%] font-semibold ">
        {props?.label}
      </p>

      <div className="bg-white flex-shrink-0 gap-x-4 justify-center flex flex-row h-full">
        {Array.from({
          length: 5,
        }).map((_r, idx) => (
          <button
            key={uuid()}
            onClick={() => {
              if (props.onStarsChange) props.onStarsChange(idx + 1);
            }}
          >
            <FeedbackIcon
              className={"w-12 h-auto"}
              color={idx + 1 > props.stars ? "#8065C930" : "#8065C9"}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default FeedbackOptionDesktop;
